var storefrontApp = angular.module('storefrontApp');


storefrontApp.controller('productPaginationController', ['$scope', '$window', '$timeout', 'catalogService',
    function ($scope, $window, $timeout, catalogService) {

        var ItemInfo = 1;
        var ItemAssets = 1 << 1;
        var Seo = 1 << 6;
        //var Inventory = 1 << 8;
        var Outlines = 1 << 9;
        var ItemWithPrices = 1 << 20;
        var ItemWithDiscounts = 1 << 21;
        var ProductRating = 1 << 25;

        $scope.Products = [];
        $scope.searching = false;
        $scope.disableSearching = false;
        $scope.searchCriteria = {
            pageNumber: 0,
            pageSize: ($window.fetchSize | 20),
            responseGroup: ItemInfo | ItemAssets | Seo | Outlines | ItemWithPrices | ItemWithDiscounts | ProductRating
        };

        var last;
        var threshold = 200;
        var dalay = 400;

        // Fetch more items
        $scope.getMoreProducts = function () {

            var now = +new Date();

            if (last && now < last + threshold) {
                return;
            }
            last = now;

            $scope.searching = true;
            var searchCriteria = Object.assign({}, $scope.searchCriteria);
            searchCriteria.pageNumber = searchCriteria.pageNumber + 1;
            catalogService.search(searchCriteria).then(function (response) {
                $scope.searchCriteria.pageNumber = response.data.metaData.pageNumber;
                $scope.disableSearching = response.data.metaData.isLastPage;

                var products = response.data.products;
                // Append the items to the list
                $scope.Products = $scope.Products.concat(products);
                $timeout(function () { $scope.searching = false; }, dalay);
            });
        };

        $scope.init = function (searchCriteria, extractQueryString) {
            $scope.searchCriteria = Object.assign({}, $scope.searchCriteria, searchCriteria);
            if (extractQueryString) {

                var queryParams = {};
                if (location.search.length) {
                    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                        aKeyValue = aCouples[i].split('=');
                        if (aKeyValue.length > 1) {
                            queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1].replace(/\+/g, ' '));
                        }
                    }
                }

                $scope.searchCriteria.keyword = queryParams["q"] || queryParams["keyword"];
                $scope.searchCriteria.sortBy = queryParams["sort_by"];
                $scope.searchCriteria.isFuzzySearch = queryParams["fuzzy"];
                if (queryParams["terms"]) {
                    var filters = queryParams["terms"].split(";");
                    var terms = [];
                    for (var i = 0; i < filters.length; i++) {
                        var filter = filters[i].split(":");
                        terms.push({ "name": filter[0], "value": filter[1] });
                    }
                    $scope.searchCriteria.terms = terms;
                }
                if (queryParams["price"]) {
                    var filters = queryParams["price"].split(";");
                    var priceRange = {
                        lower: null,
                        upper: null,
                        includeLower: true,
                        includeUpper: true
                    };
                    for (var i = 0; i < filters.length; i++) {
                        var filter = filters[i].split(":");
                        if (filter[0] === "include_lower") {
                            priceRange.includeLower = filter[1];
                        }
                        else if (filter[0] === "include_upper") {
                            priceRange.includeUpper = filter[1];
                        }
                        else if (filter[0] === "upper") {
                            priceRange.upper = filter[1];
                        }
                        else if (filter[0] === "lower") {
                            priceRange.lower = filter[1];
                        }
                    }
                    $scope.searchCriteria.priceRange = priceRange;
                }
                $scope.searchCriteria.responseGroup = queryParams["resp_group"] || $scope.searchCriteria.responseGroup;
                $scope.searchCriteria.pageNumber = queryParams["page"] || 1;
                $scope.searchCriteria.pageSize = queryParams["page_size"];
            }
        }
    }])

